__turbopack_context__.v({
  "main": "Main-module-scss-module__b5v_iW__main",
});
